import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import ResponsiveEmbed from "react-responsive-embed";
import CreditCard from "@material-ui/icons/CreditCard";
import Smartphone from "@material-ui/icons/Smartphone";

function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {props.children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
};

const styles = theme => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
});

class SimpleTabs extends React.Component {
  state = {
      value: 0,
  };

  handleChange = (event, value) => {
      this.setState({ value });
  };

  render() {
      const { classes } = this.props;
      const { value } = this.state;

      return (
          <div className={classes.root}>
              <AppBar position="static">
                  <Tabs value={value} onChange={this.handleChange}>
                      {/*<Tab label="Seamless Payments" icon={<Smartphone />} />*/}
                      {/*<Tab label="Checkout Plugin" icon={<CreditCard />} />*/}
                      <Tab label="Recurring / One time Plugin" icon={<CreditCard />} />
                      <Tab label="Payment Link" icon={<CreditCard />} />
                      {/* <Tab label="DirectPay IPG" icon={<CreditCard />} /> */}
                  </Tabs>
              </AppBar>
              {/*{value === 0 && <TabContainer style={{height:"100%"}}>*/}
              {/*    <ResponsiveEmbed src='https://developer.directpay.lk/apidoc' ratio='4:3' />*/}
              {/*</TabContainer>}*/}
              {/*{value === 0 && <TabContainer>*/}
              {/*    <ResponsiveEmbed src='https://developer.directpay.lk/cardIpg/' ratio='4:3' />*/}
              {/*</TabContainer>}*/}
              {value === 0 && <TabContainer>
                  <ResponsiveEmbed src='https://developer.directpay.lk/cardPayment/' ratio='4:3' />
              </TabContainer>}
              {value === 1 && <TabContainer>
                  <ResponsiveEmbed src='https://developer.directpay.lk/paymentlink/' ratio='4:3' />
              </TabContainer>}
          </div>
      );
  }
}

SimpleTabs.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SimpleTabs);
